import { BdNumberFormatter } from '@bindoc-projects/util-domain-lib';

export type VirtualClinicAnalysisOperatingNumberFormattingType =
  | 'manual'
  | 'currency'
  | 'percent';

export class VirtualClinicAnalysisOperatingNumberFormattingFactory {
  public static fromObject(
    obj: any = {}
  ): VirtualClinicAnalysisOperatingNumberFormatting {
    let result = null;

    switch (obj.type) {
      case 'percent':
        result = new VirtualClinicAnalysisOperatingNumberFormattingPercent(
          obj.format
        );
        break;
      case 'currency':
        result = new VirtualClinicAnalysisOperatingNumberFormattingCurrency(
          obj.format
        );
        break;
      case 'manual':
        result = new VirtualClinicAnalysisOperatingNumberFormatting(
          obj.format,
          obj.label
        );
    }

    return result;
  }
}

export class VirtualClinicAnalysisOperatingNumberFormatting {
  public type: VirtualClinicAnalysisOperatingNumberFormattingType;

  constructor(public format: Intl.NumberFormatOptions, public label: string) {
    this.type = 'manual';
  }

  public value(value: number): number {
    return value;
  }

  public formatFnc(value: number, showLabel = false): string {
    let formatted = null;

    if (showLabel && !!this.label) {
      formatted = `${BdNumberFormatter.format(value, this.format)} ${
        this.label
      }`;
    } else {
      formatted = BdNumberFormatter.format(value, this.format);
    }

    return formatted;
  }

  public clone(): VirtualClinicAnalysisOperatingNumberFormatting {
    return VirtualClinicAnalysisOperatingNumberFormattingFactory.fromObject({
      type: this.type,
      format: JSON.parse(JSON.stringify(this.format)),
      label: this.label,
    });
  }
}

export class VirtualClinicAnalysisOperatingNumberFormattingCurrency extends VirtualClinicAnalysisOperatingNumberFormatting {
  constructor(
    format: Intl.NumberFormatOptions = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }
  ) {
    super(format, '€');

    this.type = 'currency';
  }
}

export class VirtualClinicAnalysisOperatingNumberFormattingPercent extends VirtualClinicAnalysisOperatingNumberFormatting {
  constructor(
    format: Intl.NumberFormatOptions = {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }
  ) {
    super(format, '%');

    this.type = 'percent';
  }

  public override value(value: number): number {
    return super.value(value * 100);
  }

  public override formatFnc(value: number, showLabel = false): string {
    const valueNew = this.value(value);
    return super.formatFnc(valueNew, showLabel);
  }

  /**
   * Workaround to format numbers that are already converted to percent (multiplied by 100)
   * @param value
   * @param showLabel
   */
  public formatPercentValueFnc(value: number, showLabel = false): string {
    return super.formatFnc(value, showLabel);
  }
}
